import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'components/shared/Badge';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledContent,
  StyledImage,
  StyledSection
} from './Benchmark.styled';

const Benchmark: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');
  const { locale } = useRouter();

  return (
    <StyledSection>
      <StyledContainer>
        <StyledContent>
          <Badge variant="secondaryInverse">{t('benchmark.soon')}</Badge>
          <Heading3 as="h4">{t('benchmark.title')}</Heading3>
          <p>{t('benchmark.desc')}</p>
          <Link
            href={`${getAppUrl(
              APP_URLS.join,
              locale
            )}?locale=${locale}&source=banner-career-report`}
            passHref
          >
            <ButtonLink
              variant="brandTalent"
              onClick={(e) =>
                ServiceEventTracking.trackExternalLandingCtaClicked(
                  e,
                  `${getAppUrl(
                    APP_URLS.join,
                    locale
                  )}?locale=${locale}&source=banner-career-report`,
                  'banner-career-report'
                )
              }
            >
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>{t('benchmark.cta')}</span>
            </ButtonLink>
          </Link>
        </StyledContent>
        <StyledImage>
          <img
            src={getPublicPath('/images/stateSector/benchmark.svg')}
            alt=""
          />
        </StyledImage>
      </StyledContainer>
    </StyledSection>
  );
};

export default Benchmark;
